import React, { useState, useEffect } from 'react';
import { User, EyeOff, Eye, Shield, Bell, Smartphone, CheckCircle, Loader2, Camera, X, Check, Copy, HelpCircle, Mail } from 'lucide-react';
import { buildLoginUrl } from '@/api/auth/oidcConfig';
import PasswordChecklist from "../../components/PasswordChecklist";
import { useApp } from "@/contexts/AppContext";
import { getDetails, changePassword, DeviceLinked, REVOKE_DEVICE, GET_NOTIFICATION, UPDATE_NOTIFICATION, UPLOAD_PROFILE, ADD_DEVICE, UPDATE_PROFILE_DETAILS, TWOAUTH_ENABLE, TWOAUTH_VERIFY, TWOAUTH_DISABLE, GET_TWOFA_STATUS } from '../../api/services/profileService';
import { useTranslation } from 'react-i18next';
import SupportCenter from '@/components/SupportCenter';
import { getErrorMessage } from '@/utils/errorUtils';

export default function ProfileSettings() {
  const { i18n } = useTranslation();
  const [langOverride, setLangOverride] = useState(
    localStorage.getItem('i18nextLng')?.startsWith('fr') ? 'fr' : 'en'
  );
  const t = i18n.getFixedT(langOverride);
  const [activeTab, setActiveTab] = useState('profile');
  const [showSuccess, setShowSuccess] = useState(false);
  const [error, setError] = useState("");
  const [currentPassword, setCurrentPassword] = useState('');
  const [twofaAuthcurrentPassword, settwofaAuthpassword] = useState('');
  const [twofaAuthShowPassword, settwofaAuthShowPassword] = useState(false);
  const [isdisabled, setisdisabled] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);
  const [twofaLoading, setTwofaLoading] = useState(true);
  const [twofaAvailableMethods, setTwofaAvailableMethods] = useState<string[]>([]);
  const [twofaActionLoading, setTwofaActionLoading] = useState(false);
  const [twofaDisablePassword, setTwofaDisablePassword] = useState('');
  const [twofaDisableShowPwd, setTwofaDisableShowPwd] = useState(false);
  const [subscriptionRenewal, setSubscriptionRenewal] = useState(true);
  const [lowDataAlerts, setLowDataAlerts] = useState(true);
  const [paymentUpdates, setPaymentUpdates] = useState(true);
  const [connectionEvents, setConnectionEvents] = useState(false);
  
  // 2FA Modal states
  const [show2FAModal, setShow2FAModal] = useState(false);
  const [twoFaSetupData, setTwoFaSetupData] = useState<{qrCode: string, secret: string} | null>(null);
  const [twoFaVerifyCode, setTwoFaVerifyCode] = useState('');
  const [twoFaVerifying, setTwoFaVerifying] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);
  const [twoFaMethod, setTwoFaMethod] = useState<'authenticator' | 'email'>('authenticator');
  const [show2FAEmailModal, setShow2FAEmailModal] = useState(false);
  const { theme, user, setUser } = useApp();
  
  const [profile, setprofile] = useState({
    firstName: "",
    lastName: "",
    fullName: "",
    phoneNumber: "",
    email: "",
    emailVerified: false,
    profileImage: ""
  });


    const [showPassword, setShowPassword] = useState({
    currentPassword: false,
    newPassword: false,
    confirmPassword: false 
  }); 
    // const [twoAuthshowPassword, settwoAuthShowPassword] = useState(false); 
    const [code, setcode] = useState(""); 
  const [currentpagination, setcurrentpagination] = useState(1);
  
  const [password, setpassword ] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: ""
  });
  
  const [devices, setDevices] = useState(null);
  const [selectedDeviceIds, setSelectedDeviceIds] = useState<Set<string>>(new Set());
  const [bulkRevoking, setBulkRevoking] = useState(false);
  const [pagination, setPagination] = useState(null);
  const [haspagination, sethasPagination] = useState(true);
  const [loadingpagination, setloadingPagination] = useState(false);
  const [showAddDeviceModal, setShowAddDeviceModal] = useState(false);
  const [newDevice, setNewDevice] = useState({
    deviceName: '',
    macAddress: '',
    deviceType: '',
    browser: '',
    operatingSystem: ''
  });

  const tabs = [
    { id: 'profile', name: t('enduser.profile.tabs.profile', { defaultValue: 'Profile' }), icon: User },
    { id: 'security', name: t('enduser.profile.tabs.security', { defaultValue: 'Security' }), icon: Shield },
    { id: 'notifications', name: t('enduser.profile.tabs.notifications', { defaultValue: 'Notifications' }), icon: Bell },
    { id: 'devices', name: t('enduser.profile.tabs.devices', { defaultValue: 'Devices' }), icon: Smartphone },
    { id: 'support', name: t('enduser.profile.tabs.support', { defaultValue: 'Help & Support' }), icon: HelpCircle }
  ];

  useEffect(() => {
    const storedLang = localStorage.getItem('i18nextLng');
    if (storedLang) {
      const normalized = storedLang.startsWith('fr') ? 'fr' : 'en';
      setLangOverride(normalized);
      if (i18n.language !== normalized) {
        i18n.changeLanguage(normalized);
      }
    }
    const onAppLanguageChanged = (event: Event) => {
      const next = (event as CustomEvent).detail as string;
      const normalized = next?.startsWith('fr') ? 'fr' : 'en';
      setLangOverride(normalized);
    };
    window.addEventListener('appLanguageChanged', onAppLanguageChanged as EventListener);
    return () => {
      window.removeEventListener('appLanguageChanged', onAppLanguageChanged as EventListener);
    };
  }, [i18n]);

  // Fetch 2FA status on mount so the toggle reflects the actual server state.
  useEffect(() => {
    void fetchTwofaStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

const handleImageUpload = async (e) => {
  try{
  const file = e.target.files?.[0];
  if (!file) return;

  const formData = new FormData();
  formData.append("profileImage", file); // MUST be the File object
  // Note: publicId was previously hardcoded to a test value; backend now
  // generates its own publicId. Remove this once backend confirmed.

  const uploadResponse: unknown = await UPLOAD_PROFILE(formData);
  const uploadedUrl =
    ((uploadResponse as unknown as Record<string, unknown>)?.data as unknown as Record<string, unknown> | undefined)?.avatarUrl ||
    ((uploadResponse as unknown as Record<string, unknown>)?.data as unknown as Record<string, unknown> | undefined)?.url ||
    ((uploadResponse as unknown as Record<string, unknown>)?.data as unknown as Record<string, unknown> | undefined)?.profileImage ||
    ((uploadResponse as unknown as Record<string, unknown>)?.data as unknown as Record<string, unknown> | undefined)?.avatar ||
    (uploadResponse as unknown as Record<string, unknown>)?.avatarUrl ||
    (uploadResponse as unknown as Record<string, unknown>)?.url ||
    (uploadResponse as unknown as Record<string, unknown>)?.profileImage ||
    (uploadResponse as unknown as Record<string, unknown>)?.avatar;

  const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result;
      if (typeof result === "string") {
        const finalUrl = String(uploadedUrl || result);
        setprofile((prev) => ({ ...prev, profileImage: finalUrl }));
        if (user) {
          setUser({ ...user, avatar: finalUrl });
        }
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 3000);
      }
    };
    reader.readAsDataURL(file);

      } catch (err: unknown) {
    console.error("Upload failed:", err);
  }

};



  const handleSaveChanges = async () => {
    try{
      const trimmedFullName = profile.fullName?.trim();
      const nameParts = trimmedFullName ? trimmedFullName.split(/\s+/) : [];
      const derivedFirstName = nameParts[0] || profile.firstName || "";
      const derivedLastName = nameParts.length > 1 ? nameParts.slice(1).join(" ") : profile.lastName || "";

      const payload = {
        firstName: derivedFirstName,
        lastName: derivedLastName,
        phoneNumber: profile.phoneNumber,
      };
      let response = await UPDATE_PROFILE_DETAILS(payload);
      console.log(response, 'response');
      if (user) {
        const firstName = derivedFirstName.trim();
        const lastName = derivedLastName.trim();
        const name = `${firstName} ${lastName}`.trim() || user.name;
        const initials =
          firstName && lastName
            ? `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase()
            : user.initials;
        setUser({
          ...user,
          name,
          initials,
          firstName: derivedFirstName,
          lastName: derivedLastName,
          email: profile.email,
          avatar: profile.profileImage || user.avatar,
        });
      }
      setprofile((prev) => ({
        ...prev,
        firstName: derivedFirstName,
        lastName: derivedLastName,
      }));
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 3000);
    } catch (err: unknown){
      setError(getErrorMessage(err));
      setTimeout(() => setError(""), 3000);
      
    }
  };
  
  const handleUpdatePassword = async () => {
    try {
      if (password.confirmPassword !== password.newPassword) {
        const msg = t('enduser.profile.errors.passwordMismatch', { defaultValue: 'new password and confirm password are not the same.' });
        setError(msg);
        setTimeout(() => setError(''), 3000);
        return;
      }
      let profileData: unknown = await changePassword(password);
      let data: unknown = (profileData as unknown as Record<string, unknown>).data;
      
      if ((profileData as unknown as Record<string, unknown>).success) {
        setShowSuccess(true);
      } else {
        setError(String((data as unknown as Record<string, unknown>).message || t('enduser.profile.errors.generic', { defaultValue: 'something went wrong!' })));
      }
      
      setTimeout(() => setShowSuccess(false), 3000);
    } catch (err: unknown) {
      setError(String((err as unknown as Record<string, unknown>).message || t('enduser.profile.errors.generic', { defaultValue: 'something went wrong!' })));
      setTimeout(() => setError(""), 3000);
    }
  };


  const fetchTwofaStatus = async () => {
    try {
      setTwofaLoading(true);
      const res = await GET_TWOFA_STATUS();
      if ((res as unknown as Record<string, unknown>)?.success && (res as unknown as Record<string, unknown>)?.data) {
        setTwoFactorEnabled(Boolean(((res as unknown as Record<string, unknown>).data as unknown as Record<string, unknown>).enabled));
        setTwofaAvailableMethods((((res as unknown as Record<string, unknown>).data as unknown as Record<string, unknown>).availableMethods as string[]) || []);
      }
    } catch (err: unknown) {
      console.error('Failed to fetch 2FA status', err);
    } finally {
      setTwofaLoading(false);
    }
  };

  const handleEnable2FA = async (method: 'authenticator' | 'email' = 'authenticator') => {
    try {
      setTwofaActionLoading(true);
      setTwoFaMethod(method);
      const emailToUse = user?.email || profile?.email;
      if (!emailToUse) {
         setError('User email not found. Please refresh the page.');
         setTimeout(() => setError(''), 3000);
         setTwofaActionLoading(false);
         return;
      }
      const response = await TWOAUTH_ENABLE({ email: emailToUse, method });

      const resData = response as Record<string, unknown>;
      if (resData?.success || (resData?.data as Record<string, unknown>)?.success || resData?.success !== false) {
        setTwoFactorEnabled(true);
        // Redirect to the IdP to enforce MFA setup right away (provider-portable).
        window.location.href = buildLoginUrl({
          role: user?.role || 'end-user',
          prompt: 'login',
          acrValues: 'multi-factor',
        });
      } else {
        setError(String(getErrorMessage(response) || 'Failed to enable 2FA. Please try again.'));
        setTimeout(() => setError(''), 3000);
      }
    } catch (err: unknown) {
      setError(String((err as unknown as Record<string, unknown>).message || 'Failed to enable 2FA. Please try again.'));
      setTimeout(() => setError(''), 3000);
    } finally {
      setTwofaActionLoading(false);
    }
  };

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 2000);
  };

  const handleSubmit2FAVerification = async (e: React.FormEvent) => {
    e.preventDefault();
    if (twoFaVerifyCode.length !== 6) return;
    
    // Check for email from user or profile
    const emailToUse = user?.email || profile?.email;
    if (!emailToUse) {
      setError('User email not found. Please refresh the page.');
      setTimeout(() => setError(''), 3000);
      return;
    }
    
    setTwoFaVerifying(true);
    try {
      await TWOAUTH_VERIFY({ email: emailToUse, otp: twoFaVerifyCode, method: twoFaMethod });
      setTwoFactorEnabled(true);
      setTwoFaSetupData(null);
      setShow2FAModal(false);
      setShow2FAEmailModal(false);
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 3000);
    } catch (err: unknown) {
       setError(String((err as unknown as Record<string, unknown>).message || 'Invalid verification code. Please try again.'));
       setTimeout(() => setError(''), 3000);
    } finally {
      setTwoFaVerifying(false);
    }
  };

  const handleDisable2FA = async () => {
    try {
      setTwofaActionLoading(true);
      const response = await TWOAUTH_DISABLE({});
      const resData = response as Record<string, unknown>;
      if (resData?.success || (resData?.data as Record<string, unknown>)?.success || resData?.success !== false) {
        setTwoFactorEnabled(false);
        setTwofaDisablePassword('');
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 3000);
      } else {
        setError(String((response as unknown as Record<string, unknown>)?.message || 'Failed to disable 2FA'));
        setTimeout(() => setError(''), 3000);
      }
    } catch (err: unknown) {
      setError(String((err as unknown as Record<string, unknown>).message || 'Failed to disable 2FA'));
      setTimeout(() => setError(''), 3000);
    } finally {
      setTwofaActionLoading(false);
    }
  };

  const handleSavePreferences = async () => {
    try {
      // Persist all 4 notification preferences to backend
      await UPDATE_NOTIFICATION({
        subscriptionRenewal,
        lowDataAlerts,
        paymentUpdates,
        connectionEvents
      });
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 3000);
    } catch (err: unknown) {
      setError(String((err as unknown as Record<string, unknown>)?.message || t('enduser.profile.errors.savePreferencesFailed', {
        defaultValue: 'Failed to save preferences. Please try again.'
      })));
      setTimeout(() => setError(''), 3000);
    }
  };
  
  const handleRevokeAccess = async (deviceId) => {
    try {
      await REVOKE_DEVICE(deviceId);
      setDevices(devices.filter(device => device._id !== deviceId));
      setSelectedDeviceIds((prev) => {
        const next = new Set(prev);
        next.delete(deviceId);
        return next;
      });
    } catch (err: unknown) {
      setError(getErrorMessage(err));
      setTimeout(() => setError(""), 3000);
    }
  };

  const toggleDeviceSelection = (deviceId) => {
    setSelectedDeviceIds((prev) => {
      const next = new Set(prev);
      if (next.has(deviceId)) {
        next.delete(deviceId);
      } else {
        next.add(deviceId);
      }
      return next;
    });
  };

  const handleBulkRevoke = async () => {
    const ids = Array.from(selectedDeviceIds);
    if (ids.length === 0) return;

    try {
      setBulkRevoking(true);
      const results = await Promise.allSettled(ids.map((id) => REVOKE_DEVICE(id)));
      const revokedIds = new Set(
        results
          .map((result, index) => (result.status === "fulfilled" ? ids[index] : null))
          .filter(Boolean)
      );

      if (revokedIds.size > 0) {
        setDevices((prev) => prev?.filter((device) => !revokedIds.has(device._id)) || prev);
        setSelectedDeviceIds((prev) => {
          const next = new Set(prev);
          revokedIds.forEach((id) => next.delete(id));
          return next;
        });
      }

      if (revokedIds.size !== ids.length) {
        setError(
          t('enduser.profile.devicetab.errors.partialRevoke', {
            defaultValue: 'Some devices could not be revoked. Please try again.'
          })
        );
        setTimeout(() => setError(""), 3000);
      }
    } catch (err: unknown) {
      setError(
        String((err as unknown as Record<string, unknown>).message ||
          t('enduser.profile.devicetab.errors.revokeFailed', { defaultValue: 'Failed to revoke devices.' }))
      );
      setTimeout(() => setError(""), 3000);
    } finally {
      setBulkRevoking(false);
    }
  };

  const handleAddDevice = () => {
    setShowAddDeviceModal(true);
  };

  const handleCloseModal = () => {
    setShowAddDeviceModal(false);
    setNewDevice({
      deviceName: '',
      macAddress: '',
      deviceType: '',
      browser: '',
      operatingSystem: ''
    });
  };



  const fetchDevicelinked = async (page = 1, limit = 10) => {
    try {
      setloadingPagination(true);
      let d = await DeviceLinked(page, limit);
      if (devices === null) {
        setDevices(((d as unknown as Record<string, unknown>).data as unknown as Record<string, unknown>).devices);
      } else {
        let arrdev = [...devices];
        (((d as unknown as Record<string, unknown>).data as unknown as Record<string, unknown>).devices as unknown[]).map(e => {
          arrdev.push(e);
        });
        setDevices(arrdev);
      }
      setPagination(((d as unknown as Record<string, unknown>).data as unknown as Record<string, unknown>).pagination);
      sethasPagination(Boolean((((d as unknown as Record<string, unknown>).data as unknown as Record<string, unknown>).pagination as unknown as Record<string, unknown>)?.hasMore));
    } catch (err: unknown) {
      setError(String(((err as unknown as Record<string, unknown>)?.message) || err));
      setTimeout(() => setError(""), 3000);
    } finally {
      setloadingPagination(false);
    }
  };


    const handleSubmitNewDevice = async () => {
    try {
      // Client-side validation
      if (!newDevice.deviceName?.trim()) {
        setError(t('enduser.profile.devicetab.adddevice.errors.nameRequired', {
          defaultValue: 'Device name is required'
        }));
        setTimeout(() => setError(''), 3000);
        return;
      }
      if (!newDevice.macAddress?.trim()) {
        setError(t('enduser.profile.devicetab.adddevice.errors.macRequired', {
          defaultValue: 'MAC address is required'
        }));
        setTimeout(() => setError(''), 3000);
        return;
      }
      // Validate MAC address format (XX:XX:XX:XX:XX:XX or XX-XX-XX-XX-XX-XX)
      const macRegex = /^([0-9A-Fa-f]{2}[:-]){5}[0-9A-Fa-f]{2}$/;
      if (!macRegex.test(newDevice.macAddress.trim())) {
        setError(t('enduser.profile.devicetab.adddevice.errors.macInvalid', {
          defaultValue: 'Invalid MAC address format (expected XX:XX:XX:XX:XX:XX)'
        }));
        setTimeout(() => setError(''), 3000);
        return;
      }

      const obj = { ...newDevice, os: newDevice.operatingSystem };
      delete obj.operatingSystem;
      const response = await ADD_DEVICE(obj);

      console.log('New device:', response);
      setDevices((prev)=> {
        const newDeviceObj = {
          _id: String((response as unknown as Record<string, unknown>)?.data ? (((response as unknown as Record<string, unknown>).data as Record<string, unknown>)?._id || ((response as unknown as Record<string, unknown>).data as Record<string, unknown>)?.id) : ((response as unknown as Record<string, unknown>)?._id || (response as unknown as Record<string, unknown>)?.id)),
          deviceName: obj.deviceName,
          deviceType: obj.deviceType,
          os: obj.os,
          isActive: true,
          lastUsed: ((response as unknown as Record<string, unknown>)?.data as unknown as Record<string, unknown> | undefined)?.addedAt || new Date().toISOString(),
          macAddress: ((response as unknown as Record<string, unknown>)?.data as unknown as Record<string, unknown> | undefined)?.macAddress || obj.macAddress
        };
        return [newDeviceObj, ...(prev || [])];
      });
      setShowSuccess(true);
      // fetchDevicelinked(currentpagination, 10);
      setTimeout(() => setShowSuccess(false), 3000);
      handleCloseModal();
      // Optionally refresh the device list
      // fetchDevicelinked(1, 10);
    } catch (err: unknown) {
      setError(getErrorMessage(err));
      setTimeout(() => setError(""), 3000);
    }
  };

  // TODO: notificationpref duplicates the 4 individual states above (subscriptionRenewal etc.)
  // Should be refactored to use only the individual states. Multiple JSX toggles
  // currently reference this state so removing it requires touching many lines.
  const [notificationpref, setnotificationpref] = useState<Record<string, unknown>>({
    lowDataAlerts: true,
    subscriptionRenewal: true,
    paymentUpdates: false,
    connectionEvents: false
  });

  const fetchNotification = async () => {
    try {
      let NOTIFY = await GET_NOTIFICATION();
      let data = (NOTIFY as unknown as Record<string, unknown>).data as Record<string, unknown>;
      setConnectionEvents(Boolean(data?.connectionEvents));
      setPaymentUpdates(Boolean(data?.paymentUpdates));
      setSubscriptionRenewal(Boolean(data?.subscriptionRenewal));
      setLowDataAlerts(Boolean(data?.lowDataAlerts));
      setnotificationpref({
        connectionEvents: Boolean(data?.connectionEvents),
        paymentUpdates: Boolean(data?.paymentUpdates),
        subscriptionRenewal: Boolean(data?.subscriptionRenewal),
        lowDataAlerts: Boolean(data?.lowDataAlerts)
      });
    } catch (err: unknown) {
      setError(String(((err as unknown as Record<string, unknown>)?.message) || err));
      setTimeout(() => setError(""), 3000);
    }
  };
  
  const updateNotification = async (d) => {
    try {
    let NOTIFY = await UPDATE_NOTIFICATION(notificationpref);
    let data = (NOTIFY as unknown as Record<string, unknown>).data as Record<string, unknown>;
    setConnectionEvents(Boolean(data?.connectionEvents));
    setPaymentUpdates(Boolean(data?.paymentUpdates));
    setSubscriptionRenewal(Boolean(data?.subscriptionRenewal));
    setLowDataAlerts(Boolean(data?.lowDataAlerts));
    setnotificationpref({
      connectionEvents: Boolean(data?.connectionEvents),
      paymentUpdates: Boolean(data?.paymentUpdates),
      subscriptionRenewal: Boolean(data?.subscriptionRenewal),
      lowDataAlerts: Boolean(data?.lowDataAlerts)
    });
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 3000);

  } catch (err: unknown){
    setError(String(((err as unknown as Record<string, unknown>)?.message) || err));
    setTimeout(() => setError(""), 3000);

  }
  };

  const paginationFunc = async () => {
    if (pagination?.hasMore === true) {
      const nextPage = currentpagination + 1;
      setcurrentpagination(nextPage);
      sethasPagination(true);
      // Pass the new page directly — don't rely on async state update
      fetchDevicelinked(nextPage, 10);
    } else {
      sethasPagination(false);
    }
  };

 async function Profile() {
  try {
    const res: unknown = await getDetails();
    const d: unknown = (res as unknown as Record<string, unknown>)?.data ?? res ?? {};
    console.log('Profile getDetails raw:', d);
    
    const first = String((d as unknown as Record<string, unknown>).firstName ?? (d as unknown as Record<string, unknown>).first_name ?? '');
    const last = String((d as unknown as Record<string, unknown>).lastName ?? (d as unknown as Record<string, unknown>).last_name ?? '');
    const full = String((d as unknown as Record<string, unknown>).fullName ?? (d as unknown as Record<string, unknown>).name ?? `${first} ${last}`.trim());
    
    const emailVerified = Boolean((d as unknown as Record<string, unknown>).emailVerified ?? (d as unknown as Record<string, unknown>).isEmailVerified ?? (d as unknown as Record<string, unknown>).isVerified ?? (d as unknown as Record<string, unknown>).verified);
    const profileImage = String((d as unknown as Record<string, unknown>).profileImage ?? (d as unknown as Record<string, unknown>).avatar ?? (d as unknown as Record<string, unknown>).avatarUrl ?? (d as unknown as Record<string, unknown>).photoUrl ?? '');
    
    setprofile((prev) => ({ 
      ...prev,
      firstName: first,
      lastName: last,
      fullName: full, 
      email: String((d as unknown as Record<string, unknown>).email ?? (d as unknown as Record<string, unknown>).emailAddress ?? ''),
      phoneNumber: String((d as unknown as Record<string, unknown>).phoneNumber ?? (d as unknown as Record<string, unknown>).phone ?? (d as unknown as Record<string, unknown>).phoneNo ?? ''),
      profileImage: profileImage,
      emailVerified: emailVerified  
    }));

    if (profileImage && user && user.avatar !== profileImage) {
      setUser({ ...user, avatar: profileImage });
    }
  } catch (e: unknown) {
    console.error('Failed to load profile details:', e);
  }
}
  

  useEffect(() => {
    fetchDevicelinked(1, 10);
    Profile();
    fetchNotification();
    fetchTwofaStatus();
  }, []);

 

  

  return (
    <div className={`min-h-screen ${theme === 'dark' ? 'bg-black' : 'bg-gray-50'}`}>
      <div className="fixed top-4 right-4 z-50"></div>
  
      <div className="w-full px-4 sm:px-8 py-6 sm:py-8">
        <div className="max-w-15xl mx-auto">
          <div className="mb-8">
            <h1 className={`text-3xl font-bold mb-2 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
              {t('enduser.profile.headertitle', { defaultValue: 'Account Settings' })}
            </h1>
            <p className={theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}>
              {t('enduser.profile.headerbody1', { defaultValue: 'Manage your profile and preferences' })}
            </p>
          </div>

         <div className={`flex sm:inline-flex overflow-x-auto rounded-lg border mb-8 no-scrollbar ${theme === 'dark' ? 'border-gray-700 bg-gray-800/50' : 'border-gray-200 bg-white'}`}>
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center gap-2 py-2.5 px-4 sm:px-5 whitespace-nowrap transition-all ${
                    activeTab === tab.id
                      ? 'text-gray-600 bg-gray-200 rounded-md'
                      : theme === 'dark'
                        ? 'text-gray-400 hover:text-gray-300'
                        : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  <Icon className="w-[18px] h-[18px]" />
                  <span className="font-semibold text-sm tracking-tight">{tab.name}</span>
                </button>
              );
            })}
          </div>

          {activeTab === 'profile' && (
            <div className={`rounded-lg border p-4 sm:p-8 ${
              theme === 'dark' 
                ? 'bg-[#333436] border-gray-800' 
                : 'bg-white border-gray-200'
            }`}>
              <div className="mb-8">
                <h2 className={`text-xl font-semibold mb-1 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                  {t('enduser.profile.profiletab.headertitle', { defaultValue: 'Personal Information' })}
                </h2>
                <p className={`text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
                  {t('enduser.profile.profiletab.headerbody', { defaultValue: 'Update your account details' })}
                </p>
              </div>
              

              <div className="flex flex-col lg:flex-row gap-8 items-start">
                <div className="flex-shrink-0 flex flex-col items-center gap-4 w-full lg:w-auto">
                  <div className="relative group">
                    <div className={`w-32 h-32 sm:w-40 sm:h-40 rounded-full overflow-hidden border-4 ${
                      theme === 'dark' ? 'border-gray-700' : 'border-gray-200'
                    } shadow-lg ${!profile.profileImage ? (theme === 'dark' ? 'bg-gray-800' : 'bg-gray-100') : ''}`}>
                      {profile.profileImage ? (
                        <img 
                          src={profile.profileImage} 
                          alt="Profile" 
                          className="w-full h-full object-cover"
                        />
                      ) : (
                        <div className="w-full h-full flex items-center justify-center">
                          <User className={`w-16 h-16 ${theme === 'dark' ? 'text-gray-600' : 'text-gray-400'}`} />
                        </div>
                      )}
                    </div>
                    
                    <label className={`absolute inset-0 flex items-center justify-center rounded-full cursor-pointer transition-all opacity-0 group-hover:opacity-100 ${
                      theme === 'dark' ? 'bg-black/60' : 'bg-white/80'
                    }`}>
                      <input 
                        type="file" 
                        accept="image/*" 
                        onChange={handleImageUpload}
                        className="hidden"
                      />
                      <div className="text-center">
                        <Camera className={`w-8 h-8 mx-auto mb-1 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`} />
                        <span className={`text-xs font-medium ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                          {profile.profileImage
                            ? t('enduser.profile.profiletab.photo.change', { defaultValue: 'Change Photo' })
                            : t('enduser.profile.profiletab.photo.upload', { defaultValue: 'Upload Photo' })}
                        </span>
                      </div>
                    </label>
                  </div>
                  
                  
                </div>

                <div className="flex-1 w-full space-y-6">
                 
              <div className="space-y-6">
                <div>
                  <label className={`block text-sm font-medium mb-2 ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
                    {t('enduser.profile.profiletab.fullName', { defaultValue: 'Full Name' })}
                  </label>
                  <input
                    type="text"
                    value={profile.fullName}
                    onChange={(e) => setprofile((prev)=> ({...prev, fullName: e.target.value}))}
                    className={`w-full px-4 py-2.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                      theme === 'dark'
                        ? 'bg-black border-gray-700 text-white'
                        : 'bg-white border-gray-300 text-gray-900'
                    } border`}
                  />
                </div>

{/* Email Input */}

                <div>
                  <label className={`block text-sm font-medium mb-2 ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
                    {t('enduser.profile.profiletab.Email', { defaultValue: 'Email' })}
                  </label>
                  <input
                    type="email"
                    value={profile.email}
                    readOnly
                    className={`w-full px-4 py-2.5 rounded-lg focus:outline-none ${
                      theme === 'dark'
                        ? 'bg-gray-900 border-gray-700 text-gray-400 cursor-not-allowed'
                        : 'bg-gray-50 border-gray-300 text-gray-600 cursor-not-allowed'
                    } border`}
                  />
                  <div className="flex items-center gap-2 mt-2">
                    {profile.emailVerified ? (
                      <>
                        <CheckCircle className="w-4 h-4 text-green-500" />
                        <span className="text-sm text-green-600 font-medium">
                          {t('enduser.profile.profiletab.emailhadler.success', { defaultValue: 'Email verified' })}
                        </span>
                      </>
                    ) : (
                      <>
                        <X className="w-4 h-4 text-amber-500" />
                        <span className="text-sm text-amber-600 font-medium">
                          {t('enduser.profile.profiletab.emailhadler.pending', { defaultValue: 'Email not verified' })}
                        </span>
                      </>
                    )}
                  </div>
                </div>

{/* Phone Number Input */}

                <div>
                  <label className={`block text-sm font-medium mb-2 ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
                    {t('enduser.profile.profiletab.phoneNumber', { defaultValue: 'Phone Number (Optional)' })}
                  </label>
                  <input
                    type="tel"
                    value={profile.phoneNumber}
                    onChange={(e) => setprofile((prev)=> ({...prev, phoneNumber: e.target.value}))}
                    className={`w-full px-4 py-2.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                      theme === 'dark'
                        ? 'bg-black border-gray-700 text-white'
                        : 'bg-white border-gray-300 text-gray-900'
                    } border`}
                  />
                </div>

                  <div className="pt-2">
                    <button
                      onClick={handleSaveChanges}
                      className="px-6 py-2.5 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
                    >
                      {t('enduser.profile.profiletab.button', { defaultValue: 'Save Changes' })}
                    </button>
                  </div>
                </div>
              </div>
            </div>
         </div>
          )}

          {activeTab === 'security' && (
            <div className="space-y-6">
              <div className={`rounded-lg border p-4 sm:p-8 ${
                theme === 'dark' 
                  ? 'bg-[#333436] border-gray-800' 
                  : 'bg-white border-gray-200'
              }`}>
                <div className="mb-6">
                  <h2 className={`text-xl font-semibold mb-1 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                    {t('enduser.profile.settingtab.changepassword.headertitle', { defaultValue: 'Change Password' })}
                  </h2>
                  <p className={`text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
                    {t('enduser.profile.settingtab.changepassword.body', { defaultValue: 'Update your password regularly for security' })}
                  </p>
                </div>

                <div className="space-y-6">
                  <div>
                    <label className={`block text-sm font-medium mb-2 ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
                      {t('enduser.profile.settingtab.changepassword.currentpassword', { defaultValue: 'Current Password' })}
                    </label>
                    <div className="relative">
                    <input
                      type={showPassword.currentPassword ? "text" : "password"}
                       value={password.currentPassword}
                      onChange={(e) => {
                        setpassword((prev) => ({ ...prev, currentPassword: e.target.value }));
                      }}
                      className={`w-full px-4 py-2.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                        theme === 'dark'
                          ? 'bg-black border-gray-700 text-white'
                          : 'bg-white border-gray-300 text-gray-900'
                      } border`}
                    />
                    <button
                                      type="button"
                                      onClick={() => {
                                       setShowPassword((prev)=> ({...prev, currentPassword: !showPassword.currentPassword}))
                                      }}
                                      className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                                    >
                                      {showPassword.currentPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                                    </button>
                                    </div>
                  </div>

                  <div>
                    <label className={`block text-sm font-medium mb-2 ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
                      {t('enduser.profile.settingtab.changepassword.newpassword', { defaultValue: 'New Password' })}
                    </label>
                    <div className="relative">
                    <input
                      type={showPassword.newPassword ? "text" : "password"}
                      value={password.newPassword}
                      onChange={(e) => setpassword((prev) => ({ ...prev, newPassword: e.target.value }))}
                      className={`w-full px-4 py-2.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                        theme === 'dark'
                          ? 'bg-black border-gray-700 text-white'
                          : 'bg-white border-gray-300 text-gray-900'
                      } border`}
                    />
                    <button
                                      type="button"
                                      onClick={() => {
                                       setShowPassword((prev)=> ({...prev, newPassword: !showPassword.newPassword}))
                                      }}
                                      className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                                    >
                                      {showPassword.newPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                                    </button>
                                    </div>
                    <PasswordChecklist password={password.newPassword} />
                  </div>

                  <div>
                    <label className={`block text-sm font-medium mb-2 ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
                      {t('enduser.profile.settingtab.changepassword.confirmpassword', { defaultValue: 'Confirm New Password' })}
                    </label>
                    <div className="relative">
                    <input
                      type={showPassword.confirmPassword ? "text" : "password"}
                      value={password.confirmPassword}
                      onChange={(e) => setpassword((prev) => ({ ...prev, confirmPassword: e.target.value }))}
                      className={`w-full px-4 py-2.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                        theme === 'dark'
                          ? 'bg-black border-gray-700 text-white'
                          : 'bg-white border-gray-300 text-gray-900'
                      } border`}
                    />
                        <button type="button"
                                      onClick={() => {
                                       setShowPassword((prev)=> ({...prev, confirmPassword: !showPassword.confirmPassword}))
                                      }}
                                      className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                                    >
                                      {showPassword.confirmPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                                    </button>
                  </div>
                </div>

                  <div className="pt-2">
                    <button
                      onClick={handleUpdatePassword}
                      className="px-6 py-2.5 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
                    >
                      {t('enduser.profile.settingtab.changepassword.button', { defaultValue: 'Update Password' })}
                    </button>
                  </div>
                </div>
              </div>


              <div className={`rounded-lg border p-4 sm:p-8 ${
                theme === 'dark'
                  ? 'bg-[#333436] border-gray-800'
                  : 'bg-white border-gray-200'
              }`}>
                <div className="mb-6">
                  <h2 className={`text-xl font-semibold mb-1 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                    {t('enduser.profile.settingtab.twofactor.headertitle', { defaultValue: 'Two-Factor Authentication' })}
                  </h2>
                  <p className={`text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
                    {t('enduser.profile.settingtab.twofactor.body', { defaultValue: 'Add an extra layer of security to your account' })}
                  </p>
                </div>

                {twofaLoading ? (
                  <div className="flex items-center gap-3 py-4">
                    <Loader2 className="w-5 h-5 animate-spin text-blue-500" />
                    <span className={`text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-500'}`}>{t('enduser.profile.settingtab.twofactor.loading', { defaultValue: 'Loading 2FA status...' })}</span>
                  </div>
                ) : (
                  <div className="space-y-6">
                    <div className={`flex items-center gap-3 rounded-lg p-4 ${
                      twoFactorEnabled
                        ? theme === 'dark' ? 'bg-green-900/20 border border-green-700' : 'bg-green-50 border border-green-200'
                        : theme === 'dark' ? 'bg-yellow-900/20 border border-yellow-700' : 'bg-yellow-50 border border-yellow-200'
                    }`}>
                      <div className={`w-3 h-3 rounded-full flex-shrink-0 ${twoFactorEnabled ? 'bg-green-500' : 'bg-yellow-500'}`} />
                      <p className={`text-sm font-medium ${
                        twoFactorEnabled
                          ? theme === 'dark' ? 'text-green-300' : 'text-green-700'
                          : theme === 'dark' ? 'text-yellow-300' : 'text-yellow-700'
                      }`}>
                        {twoFactorEnabled
                          ? t('enduser.profile.settingtab.twofactor.statusEnabled', { defaultValue: '2FA is currently enabled. Your account has extra protection.' })
                          : t('enduser.profile.settingtab.twofactor.statusDisabled', { defaultValue: '2FA is not enabled. Enable it for better account security.' })}
                      </p>
                    </div>

                    {twoFactorEnabled && (
                      <div className="space-y-3">
                        <label className={`block text-sm font-medium ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
                          Enter your password to disable 2FA
                        </label>
                        <div className="relative">
                          <input
                            type={twofaDisableShowPwd ? 'text' : 'password'}
                            value={twofaDisablePassword}
                            onChange={(e) => setTwofaDisablePassword(e.target.value)}
                            placeholder="Your current password"
                            className={`w-full px-4 py-2.5 pr-12 rounded-lg border focus:outline-none focus:ring-2 focus:ring-red-500 ${
                              theme === 'dark'
                                ? 'bg-black border-gray-700 text-white placeholder-gray-500'
                                : 'bg-white border-gray-300 text-gray-900 placeholder-gray-400'
                            }`}
                          />
                          <button
                            type="button"
                            onClick={() => setTwofaDisableShowPwd((p) => !p)}
                            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                          >
                            {twofaDisableShowPwd ? <EyeOff size={18} /> : <Eye size={18} />}
                          </button>
                        </div>
                        <button
                          onClick={handleDisable2FA}
                          disabled={twofaActionLoading || !twofaDisablePassword.trim()}
                          className="flex items-center gap-2 px-6 py-2.5 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                        >
                          {twofaActionLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Shield className="w-4 h-4" />}
                          {twofaActionLoading ? 'Disabling...' : 'Disable 2FA'}
                        </button>
                      </div>
                    )}

                    {!twoFactorEnabled && (
                      <div className="pt-2 space-y-3">
                        <p className={`text-sm font-medium ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
                          Choose how you want to receive your verification:
                        </p>

                        {/* Authenticator app */}
                        <button
                          onClick={() => handleEnable2FA('authenticator')}
                          disabled={twofaActionLoading}
                          className={`w-full flex items-center gap-4 p-4 rounded-xl border text-left transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
                            theme === 'dark'
                              ? 'bg-black/30 border-gray-700 hover:border-blue-500 hover:bg-blue-900/10'
                              : 'bg-white border-gray-200 hover:border-blue-500 hover:bg-blue-50'
                          }`}
                        >
                          <div className="shrink-0 rounded-lg bg-blue-600/20 p-2.5">
                            <Shield className="w-5 h-5 text-blue-400" />
                          </div>
                          <div className="flex-1">
                            <p className={`text-sm font-semibold ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                              Authenticator App
                            </p>
                            <p className={`text-xs mt-0.5 ${theme === 'dark' ? 'text-gray-400' : 'text-gray-500'}`}>
                              Use Authy, Google Authenticator, or Microsoft Authenticator
                            </p>
                          </div>
                          {twofaActionLoading && twoFaMethod === 'authenticator' && <Loader2 className="w-4 h-4 animate-spin text-blue-400" />}
                        </button>

                        {/* Email */}
                        <button
                          onClick={() => handleEnable2FA('email')}
                          disabled={twofaActionLoading}
                          className={`w-full flex items-center gap-4 p-4 rounded-xl border text-left transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
                            theme === 'dark'
                              ? 'bg-black/30 border-gray-700 hover:border-blue-500 hover:bg-blue-900/10'
                              : 'bg-white border-gray-200 hover:border-blue-500 hover:bg-blue-50'
                          }`}
                        >
                          <div className="shrink-0 rounded-lg bg-blue-600/20 p-2.5">
                            <Mail className="w-5 h-5 text-blue-400" />
                          </div>
                          <div className="flex-1">
                            <p className={`text-sm font-semibold ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                              Email
                            </p>
                            <p className={`text-xs mt-0.5 ${theme === 'dark' ? 'text-gray-400' : 'text-gray-500'}`}>
                              Get a verification code sent to your email
                            </p>
                          </div>
                          {twofaActionLoading && twoFaMethod === 'email' && <Loader2 className="w-4 h-4 animate-spin text-blue-400" />}
                        </button>

                        {/* SMS - coming soon (disabled) */}
                        <div
                          className={`w-full flex items-center gap-4 p-4 rounded-xl border text-left opacity-60 cursor-not-allowed ${
                            theme === 'dark' ? 'bg-black/20 border-gray-800' : 'bg-gray-50 border-gray-200'
                          }`}
                        >
                          <div className="shrink-0 rounded-lg bg-gray-500/20 p-2.5">
                            <Smartphone className="w-5 h-5 text-gray-400" />
                          </div>
                          <div className="flex-1">
                            <p className={`text-sm font-semibold ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
                              SMS / Phone
                            </p>
                            <p className={`text-xs mt-0.5 ${theme === 'dark' ? 'text-gray-500' : 'text-gray-400'}`}>
                              Coming soon
                            </p>
                          </div>
                          <span className={`text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded-full ${theme === 'dark' ? 'bg-gray-700 text-gray-300' : 'bg-gray-200 text-gray-600'}`}>
                            Soon
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}

          {activeTab === 'notifications' && (
            <div className={`rounded-lg border p-4 sm:p-8 ${
              theme === 'dark' 
                ? 'bg-[#333436] border-gray-800' 
                : 'bg-white border-gray-200'
            }`}>
              <div className="mb-6">
                <h2 className={`text-xl font-semibold mb-1 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                  {t('enduser.profile.notificationtab.headertitle', { defaultValue: 'Notification Preferences' })}
                </h2>
                <p className={`text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
                  {t('enduser.profile.notificationtab.body1', { defaultValue: 'Choose what updates you want to receive' })}
                </p>
              </div>

              <div className="space-y-6">
                <div className={`flex items-start justify-between py-4 border-b ${theme === 'dark' ? 'border-gray-700' : 'border-gray-200'}`}>
                  <div className="flex-1">
                    <h3 className={`text-base font-semibold mb-1 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                      {t('enduser.profile.notificationtab.options.0.title', { defaultValue: 'Subscription Renewal' })}
                    </h3>
                    <p className={`text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
                      {t('enduser.profile.notificationtab.options.0.desc', { defaultValue: 'Get notified before your plan renews' })}
                    </p>
                  </div>
                  <button
                    onClick={() => {
                      setSubscriptionRenewal((prev) => !prev);
                      setnotificationpref((prev) => ({ ...prev, subscriptionRenewal: !prev.subscriptionRenewal }));
                    }}
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                      subscriptionRenewal ? 'bg-blue-600' : 'bg-gray-300'
                    }`}
                  >
                    <span
                      className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                        subscriptionRenewal ? 'translate-x-6' : 'translate-x-1'
                      }`}
                    />
                  </button>
                </div>

                <div className={`flex items-start justify-between py-4 border-b ${theme === 'dark' ? 'border-gray-700' : 'border-gray-200'}`}>
                  <div className="flex-1">
                    <h3 className={`text-base font-semibold mb-1 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                      {t('enduser.profile.notificationtab.options.1.title', { defaultValue: 'Low Data Alerts' })}
                    </h3>
                    <p className={`text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
                      {t('enduser.profile.notificationtab.options.1.desc', { defaultValue: "Notify when you've used 80% of your data" })}
                    </p>
                  </div>
                  <button
                    onClick={() => {
                      setLowDataAlerts((prev) => !prev);
                      setnotificationpref((prev) => ({ ...prev, lowDataAlerts: !prev.lowDataAlerts }));
                    }}
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                      lowDataAlerts ? 'bg-blue-600' : 'bg-gray-300'
                    }`}
                  >
                    <span
                      className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                        lowDataAlerts ? 'translate-x-6' : 'translate-x-1'
                      }`}
                    />
                  </button>
                </div>

                <div className={`flex items-start justify-between py-4 border-b ${theme === 'dark' ? 'border-gray-700' : 'border-gray-200'}`}>
                  <div className="flex-1">
                    <h3 className={`text-base font-semibold mb-1 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                      {t('enduser.profile.notificationtab.options.2.title', { defaultValue: 'Payment Updates' })}
                    </h3>
                    <p className={`text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
                      {t('enduser.profile.notificationtab.options.2.desc', { defaultValue: 'Receive payment confirmations and receipts' })}
                    </p>
                  </div>
                  <button
                    onClick={() => {
                      setPaymentUpdates((prev) => !prev);
                      setnotificationpref((prev) => ({ ...prev, paymentUpdates: !prev.paymentUpdates }));
                    }}
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                      paymentUpdates ? 'bg-blue-600' : 'bg-gray-300'
                    }`}
                  >
                    <span
                      className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                        paymentUpdates ? 'translate-x-6' : 'translate-x-1'
                      }`}
                    />
                  </button>
                </div>

                <div className="flex items-start justify-between py-4">
                  <div className="flex-1">
                    <h3 className={`text-base font-semibold mb-1 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                      {t('enduser.profile.notificationtab.options.3.title', { defaultValue: 'Connection Events' })}
                    </h3>
                    <p className={`text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
                      {t('enduser.profile.notificationtab.options.3.desc', { defaultValue: 'Notify when devices connect to hotspots' })}
                    </p>
                  </div>
                  <button
                    onClick={() => {
                      setConnectionEvents((prev) => !prev);
                      setnotificationpref((prev) => ({ ...prev, connectionEvents: !prev.connectionEvents }));
                    }}
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                      connectionEvents ? 'bg-blue-600' : 'bg-gray-300'
                    }`}
                  >
                    <span
                      className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                        connectionEvents ? 'translate-x-6' : 'translate-x-1'
                      }`}
                    />
                  </button>
                </div>

                <div className="pt-4">
                  <button
                    onClick={handleSavePreferences}
                    className="px-6 py-2.5 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
                  >
                    {t('enduser.profile.notificationtab.button', { defaultValue: 'Save Preferences' })}
                  </button>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'support' && (
            <SupportCenter theme={theme} t={(t as unknown as (...args: unknown[]) => string)} />
          )}

          {activeTab === 'devices' && (
            <div className={`rounded-lg border p-4 sm:p-8 ${
              theme === 'dark' 
                ? 'bg-[#333436] border-gray-800' 
                : 'bg-white border-gray-200'
            }`}>
              <div className="mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div>
                  <h2 className={`text-xl font-semibold mb-1 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                    {t('enduser.profile.devicetab.headertitle', { defaultValue: 'Linked Devices' })}
                  </h2>
                  <p className={`text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
                    {t('enduser.profile.devicetab.headerbody', { defaultValue: 'Manage devices authorized to connect' })}
                  </p>
                </div>
                <button
                  onClick={handleBulkRevoke}
                  disabled={selectedDeviceIds.size === 0 || bulkRevoking}
                  className={`px-4 py-2 text-sm font-medium rounded-lg border transition-colors w-full sm:w-auto ${
                    theme === 'dark'
                      ? 'text-gray-300 border-gray-600 hover:bg-gray-800'
                      : 'text-gray-700 border-gray-300 hover:bg-gray-50'
                  } disabled:opacity-50 disabled:cursor-not-allowed`}
                >
                  {bulkRevoking
                    ? t('enduser.profile.devicetab.bulkRevoking', { defaultValue: 'Revoking...' })
                    : t('enduser.profile.devicetab.bulkRevoke', {
                        defaultValue: 'Revoke All Marked',
                        count: selectedDeviceIds.size
                      }) + (selectedDeviceIds.size ? ` (${selectedDeviceIds.size})` : '')}
                </button>
              </div>

              <div className="space-y-4">
                {devices?.map((device) => (
                  <div
                    key={device._id}
                    className={`flex flex-col sm:flex-row sm:items-center gap-4 p-4 rounded-lg border transition-colors ${
                      theme === 'dark'
                        ? 'border-gray-700 hover:border-gray-600 bg-black'
                        : 'border-gray-200 hover:border-gray-300 bg-white'
                    }`}
                  >
                    <div className="flex items-start sm:items-center gap-4 w-full sm:w-auto flex-1">
                      <div className="flex-shrink-0 mt-1 sm:mt-0">
                        <button
                          type="button"
                          onClick={() => toggleDeviceSelection(device._id)}
                          className={`w-5 h-5 border-2 rounded flex items-center justify-center transition-colors ${
                            selectedDeviceIds.has(device._id)
                              ? theme === 'dark'
                                ? 'border-blue-500 bg-blue-600'
                                : 'border-blue-600 bg-blue-600'
                              : theme === 'dark'
                                ? 'border-gray-600 bg-transparent'
                                : 'border-gray-300 bg-transparent'
                          }`}
                          aria-pressed={selectedDeviceIds.has(device._id)}
                          aria-label={`Select ${device.deviceName}`}
                        >
                          {selectedDeviceIds.has(device._id) && (
                            <Check className="w-3 h-3 text-white" />
                          )}
                        </button>
                      </div>

                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 mb-0.5">
                          <h3 className={`text-base font-semibold truncate ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                            {device.deviceName}
                          </h3>
                          <span
                            className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold ${
                              device.online
                                ? 'bg-green-100 text-green-700'
                                : theme === 'dark' ? 'bg-gray-700 text-gray-400' : 'bg-gray-100 text-gray-500'
                            }`}
                          >
                            <span className={`w-1.5 h-1.5 rounded-full ${device.online ? 'bg-green-500' : 'bg-gray-400'}`} />
                            {device.online
                              ? (device.connectedHotspot ? `Connected · ${device.connectedHotspot}` : 'Connected')
                              : 'Idle'}
                          </span>
                        </div>
                        <p className={`text-sm mb-0.5 truncate ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
                          {t('enduser.profile.devicetab.devices.mac', { defaultValue: 'MAC' })}: {device.macAddress}
                        </p>
                        <p className={`text-xs ${theme === 'dark' ? 'text-gray-500' : 'text-gray-500'}`}>
                          {device.lastUsed ? new Date(device.lastUsed).toLocaleDateString() : ""}
                        </p>
                      </div>
                    </div>

                    <button
                      onClick={() => handleRevokeAccess(device._id)}
                      className={`w-full sm:w-auto px-4 py-2 text-sm font-medium rounded-lg border transition-colors ${
                        theme === 'dark'
                          ? 'text-gray-300 border-gray-600 hover:bg-gray-800'
                          : 'text-gray-700 border-gray-300 hover:bg-gray-50'
                      }`}
                    >
                      {t('enduser.profile.devicetab.devices.button', { defaultValue: 'Revoke Access' })}
                    </button>
                  </div>
                ))}
                {devices?.length === 0 && (
                  <span>{t('enduser.profile.devicetab.empty', { defaultValue: 'No devices found' })}</span>
                )}
                {haspagination === true && <button
                  onClick={paginationFunc}
                  className={`w-full py-3 text-sm font-medium rounded-lg border transition-colors flex justify-center ${
                    theme === 'dark'
                      ? 'text-gray-300 border-gray-600 hover:bg-gray-800'
                      : 'text-gray-700 border-gray-300 hover:bg-gray-50'
                  }`}
                >
                  {loadingpagination ? (
                    <Loader2 className="w-5 h-5 animate-spin text-blue-600" />
                  ) : (
                    t('enduser.profile.devicetab.loadMore', { defaultValue: 'Load More' })
                  )}
                </button>}
                <div className={`w-full mt-2 p-3 rounded-lg text-sm flex items-start gap-2 ${theme === 'dark' ? 'bg-gray-800 text-gray-300' : 'bg-gray-50 text-gray-600'}`}>
                  <Smartphone className="w-4 h-4 mt-0.5 flex-shrink-0" />
                  <span>{t('enduser.profile.devicetab.adddevice.autoHint', { defaultValue: 'Devices are added automatically when you sign in at a KonectX hotspot. You can revoke a device here to free up a slot.' })}</span>
                </div>
              </div>
            </div>
          )}
        </div>




    {/* 2FA Setup Modal */}
    {show2FAEmailModal && (
      <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[100] p-4 animate-in fade-in duration-300">
        <div className={`w-full max-w-md rounded-3xl overflow-hidden shadow-2xl ${theme === 'dark' ? 'bg-[#333436] border border-gray-700' : 'bg-white'}`}>
          <div className="p-8">
            <div className="flex justify-between items-center mb-6">
              <h3 className={`text-2xl font-bold ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>{t('enduser.profile.twofa.emailModalTitle', { defaultValue: 'Check your email' })}</h3>
              <button onClick={() => setShow2FAEmailModal(false)} className={`p-1 rounded-full transition-colors ${theme === 'dark' ? 'hover:bg-gray-700 text-gray-400' : 'hover:bg-gray-100 text-gray-500'}`}>
                <X size={24} />
              </button>
            </div>
            <div className="space-y-6">
              <div className={`p-4 rounded-2xl flex items-start gap-4 ${theme === 'dark' ? 'bg-blue-900/20' : 'bg-blue-50'}`}>
                <Mail className="w-6 h-6 text-blue-500 mt-1 flex-shrink-0" />
                <p className={`text-sm leading-relaxed ${theme === 'dark' ? 'text-blue-200' : 'text-blue-700'}`}>
                  {t('enduser.profile.twofa.emailModalDesc', { defaultValue: "We've sent a 6-digit verification code to your email. Enter it below to enable two-factor authentication." })}
                </p>
              </div>
              <form onSubmit={handleSubmit2FAVerification} className="space-y-4">
                <div className="space-y-2">
                  <label className={`text-sm font-medium ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>{t('enduser.profile.twofa.emailVerificationCode', { defaultValue: 'Verification Code' })}</label>
                  <input
                    type="text"
                    maxLength={6}
                    value={twoFaVerifyCode}
                    onChange={(e) => setTwoFaVerifyCode(e.target.value.replace(/\D/g, ''))}
                    placeholder="000000"
                    className={`w-full px-4 py-4 text-center text-2xl font-bold tracking-[0.5em] rounded-xl outline-none transition-all border-2 ${theme === 'dark' ? 'bg-black border-gray-700 text-white focus:border-blue-500' : 'bg-gray-50 border-gray-200 text-gray-900 focus:border-blue-600'}`}
                    disabled={twoFaVerifying}
                    required
                    autoFocus
                  />
                </div>
                <button
                  type="submit"
                  disabled={twoFaVerifying || twoFaVerifyCode.length !== 6}
                  className="w-full py-4 bg-blue-600 text-white font-bold rounded-xl hover:bg-blue-700 transition-all shadow-lg shadow-blue-600/20 disabled:opacity-50 flex items-center justify-center gap-2"
                >
                  {twoFaVerifying ? (<><Loader2 className="w-5 h-5 animate-spin" /> {t('enduser.profile.twofa.verifying', { defaultValue: 'Verifying...' })}</>) : (t('enduser.profile.twofa.enableBtn', { defaultValue: 'Verify & Enable 2FA' }))}
                </button>
                <button
                  type="button"
                  onClick={() => handleEnable2FA('email')}
                  disabled={twofaActionLoading}
                  className={`w-full text-sm ${theme === 'dark' ? 'text-gray-400 hover:text-gray-200' : 'text-gray-500 hover:text-gray-700'} disabled:opacity-50`}
                >
                  {t('enduser.profile.twofa.resendCode', { defaultValue: "Didn't get it? Resend code" })}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    )}

    {show2FAModal && twoFaSetupData && (
      <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[100] p-4 animate-in fade-in duration-300">
        <div 
          className={`w-full max-w-lg rounded-3xl overflow-hidden shadow-2xl transition-all duration-300 transform scale-100 ${
            theme === 'dark' ? 'bg-[#333436] border border-gray-700' : 'bg-white'
          }`}
        >
          <div className="p-8">
            <div className="flex justify-between items-center mb-6">
              <h3 className={`text-2xl font-bold ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                {t('enduser.profile.twofa.modalTitle', { defaultValue: 'Secure Your Account' })}
              </h3>
              <button 
                onClick={() => setShow2FAModal(false)}
                className={`p-1 rounded-full transition-colors ${theme === 'dark' ? 'hover:bg-gray-700 text-gray-400' : 'hover:bg-gray-100 text-gray-500'}`}
              >
                <X size={24} />
              </button>
            </div>

            <div className="space-y-6">
              <div className={`p-4 rounded-2xl flex items-start gap-4 ${theme === 'dark' ? 'bg-blue-900/20' : 'bg-blue-50'}`}>
                <Shield className="w-6 h-6 text-blue-500 mt-1 flex-shrink-0" />
                <p className={`text-sm leading-relaxed ${theme === 'dark' ? 'text-blue-200' : 'text-blue-700'}`}>
                  {t('enduser.profile.twofa.modalDesc', { defaultValue: 'Scan the QR code with your authenticator app (Google Authenticator, Authy, etc.) to get started.' })}
                </p>
              </div>

              <div className="flex justify-center p-4 bg-white rounded-2xl">
                <img 
                  src={twoFaSetupData.qrCode} 
                  alt="2FA QR Code" 
                  className="w-48 h-48"
                />
              </div>

              <div className="space-y-2">
                <p className={`text-xs font-semibold uppercase tracking-wider ${theme === 'dark' ? 'text-gray-400' : 'text-gray-500'}`}>
                  {t('enduser.profile.twofa.manualKey', { defaultValue: 'Manual Setup Key' })}
                </p>
                <div className={`flex items-center justify-between p-4 rounded-xl border ${theme === 'dark' ? 'bg-black/40 border-gray-700' : 'bg-gray-50 border-gray-200'}`}>
                  <code className={`text-sm font-mono font-bold ${theme === 'dark' ? 'text-blue-400' : 'text-blue-600'}`}>
                    {twoFaSetupData.secret}
                  </code>
                  <button 
                    onClick={() => copyToClipboard(twoFaSetupData.secret)}
                    className="flex items-center gap-2 text-xs font-medium text-blue-500 hover:text-blue-600 transition-colors"
                  >
                    {copySuccess ? (
                      <><CheckCircle size={16} /> {t('enduser.profile.twofa.copied', { defaultValue: 'Copied!' })}</>
                    ) : (
                      <><Copy size={16} /> {t('enduser.profile.twofa.copy', { defaultValue: 'Copy' })}</>
                    )}
                  </button>
                </div>
              </div>

              <form onSubmit={handleSubmit2FAVerification} className="space-y-4">
                <div className="space-y-2">
                  <label className={`text-sm font-medium ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
                    {t('enduser.profile.twofa.enterCode', { defaultValue: 'Verification Code' })}
                  </label>
                  <input
                    type="text"
                    maxLength={6}
                    value={twoFaVerifyCode}
                    onChange={(e) => setTwoFaVerifyCode(e.target.value.replace(/\D/g, ''))}
                    placeholder="000000"
                    className={`w-full px-4 py-4 text-center text-2xl font-bold tracking-[0.5em] rounded-xl outline-none transition-all ${
                      theme === 'dark' 
                        ? 'bg-black border-gray-700 text-white focus:border-blue-500' 
                        : 'bg-gray-50 border-gray-200 text-gray-900 focus:border-blue-600'
                    } border-2`}
                    disabled={twoFaVerifying}
                    required
                  />
                </div>

                <button
                  type="submit"
                  disabled={twoFaVerifying || twoFaVerifyCode.length !== 6}
                  className="w-full py-4 bg-blue-600 text-white font-bold rounded-xl hover:bg-blue-700 transition-all shadow-lg shadow-blue-600/20 disabled:opacity-50 flex items-center justify-center gap-2"
                >
                  {twoFaVerifying ? (
                    <><Loader2 className="w-5 h-5 animate-spin" /> {t('enduser.profile.twofa.verifying', { defaultValue: 'Verifying...' })}</>
                  ) : (
                    t('enduser.profile.twofa.enableBtn', { defaultValue: 'Verify & Enable 2FA' })
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    )}

        {showSuccess && (
          <div className="fixed top-6 right-6 z-50 animate-slide-in">
            <div className="bg-green-500 text-white px-6 py-4 rounded-xl shadow-2xl flex items-center gap-3">
              <CheckCircle className="w-6 h-6" />
              <div>
                <p className="font-semibold">
                  {t('enduser.profile.toast.successTitle', { defaultValue: 'Success!' })}
                </p>
                <p className="text-sm text-green-100">
                  {t('enduser.profile.toast.savedMessage', { defaultValue: 'Your changes have been saved' })}
                </p>
              </div>
            </div>
          </div>
        )}

        {error && (<div className="fixed top-6 right-6 z-50 animate-slide-in">
            <div className="bg-red-500 text-white px-6 py-4 rounded-xl shadow-2xl flex items-center gap-3">
              <X className="w-6 h-6" />
              <div>
                <p className="font-semibold">
                  {t('enduser.profile.toast.failureTitle', { defaultValue: 'Failed!' })}
                </p>
                <p className="text-sm text-red-100">{error}</p>
              </div>
            </div>
          </div>)}
  
      </div>
    </div>
  );
};
